/** « •• •• 12 34 » — seuls les 4 derniers chiffres d'un numéro sont affichés (F-26). */
export function maskAccountPhone(telephone) {
  const digits = String(telephone || '').replace(/\D/g, '');
  if (digits.length < 4) return '';
  return `•• •• ${digits.slice(-4, -2)} ${digits.slice(-2)}`;
}
